import type { ConfigSchema } from '@/types/schema';

import { getServices } from '~/db/services';

export const useConfigSyncGet = () => {
  const { $db } = useNuxtApp();
  const { configsService } = getServices($db);
  const ids = ref<string[]>(['1']);

  const request = ref<() => Promise<ConfigSchema[]>>(async () => {
    try {
      return configsService.findByIds(ids.value);
    } catch (e) {
      if (e.name === 'DatabaseClosedError') {
        globalThis.$logger.info('useConfigSyncGet :: error', e);
      } else {
        throw e;
      }
    }
  });

  const { value: config, release } = useLiveQuery<ConfigSchema[]>(
    request.value,
    ids
  );

  $db.configs.hook('deleting', () => {
    release();
  });

  return { config };
};
